module.exports = __webpack_public_path__ + "media/images/badges/tak_badge-2ab15e5737a33f323b1eb5564b2bff22.svg";